import { get, post } from ".";

let safetyInsightPromise = {};
let safetyReportsPromise = {};

export const getInsightApi = async (projectId) => {
  return await get(`safety/safety-performance?project_id=${projectId}`);
};

export const getSafetyInsightApi = async (projectId) => {
  if (safetyInsightPromise[projectId]) {
    return safetyInsightPromise[projectId];
  }
  safetyInsightPromise[projectId] = get(`safety/safety-insight?project_id=${projectId}`)
    .then((data) => {
      return data;
    })
    .finally(() => {
      safetyInsightPromise[projectId] = null;
    });
  return safetyInsightPromise[projectId];
};

// export const getSafetyInsightApi = async (projectId) => {
//   return await get(`safety/safety-insight?project_id=${projectId}`);
// };

export const getSafetyReportsApi = async (projectId, classification) => {
  const key = `${projectId}_${classification}`;
  if (safetyReportsPromise[key]) {
    return safetyReportsPromise[key];
  }
  safetyReportsPromise[key] = get(`safety/safety-reports?project_id=${projectId}&classification=${classification}`)
    .then((data) => {
      return data;
    })
    .finally(() => {
      safetyReportsPromise[key] = null;
    });
  return safetyReportsPromise[key];
};

// export const getSafetyReportsApi = async (projectId, classification) => {
//   return await get(`safety/safety-reports?project_id=${projectId}&classification=${classification}`);
// };

export const getSafetyDetailsApi = async (projectId, safetyReportId) => {
  return await get(`safety/safety-reports/details?project_id=${projectId}&safetyReportId=${safetyReportId}`);
};

export const createSafetyReportApi = async (projectId, params) => {
  return await post(`safety/safety-report?project_id=${projectId}`, params);
};

export const uploadSafetyFileApi = async (projectId, safetyReportId, params) => {
  return await post(`safety/new-sefety-report-file?project_id=${projectId}&safetyReportId=${safetyReportId}`, params);
};

export const getEquipmentTrackingApi = async (projectId) => {
  return await get(`safety/equipment-tracking?project_id=${projectId}`);
};

export const getQualificationTrackingApi = async (projectId) => {
  return await get(`safety/personnel-qualification?project_id=${projectId}`);
};

export const getQualificationHistoryApi = async (projectId) => {
  return await get(`safety/personnel-qualification-history?project_id=${projectId}`);
};

export const exportQualificationApi = async (projectId) => {
  return await get(`safety/export-qualification?project_id=${projectId}`);
};

export const uploadNewQualificationApi = async (projectId, params) => {
  return await post(`safety/new-personnel-qualification?project_id=${projectId}`, params);
};

export const downloadReportApi = async (projectId, safetyReportId) => {
  return await get(`safety/safety-reports/download?project_id=${projectId}&safetyReportId=${safetyReportId}`);
};

export const exportPerformanceApi = async (projectId) => {
  return await get(`safety/safety-performance/export?project_id=${projectId}`);
};

export const getSafetyManhoursApi = async (projectId) => {
  return await get(`safety/manhours?project_id=${projectId}`);
};

export const exportQualificationTemplateApi = async () => {
  return await get(`safety/safety-template`);
};